import { render } from "./ModalCardtable.vue?vue&type=template&id=11ddc89b"
import script from "./ModalCardtable.vue?vue&type=script&lang=js"
export * from "./ModalCardtable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__